import { prop } from 'ramda'

import { createStructuredSelector } from 'reselect'

export const selectDashboardContext = createStructuredSelector({
  breakpoint: prop('breakpoint'),
  currentFacility: prop('currentFacility'),
  dataTypes: prop('allDataTypes'),
  facilityStatus: prop('facilityStatus'),
  me: prop('me'),
  currentHarvestList: prop('currentHarvestList'),
  cultivars: prop('facilityCultivars'),
  phases: prop('phases'),
  rooms: prop('rooms'),
  zones: prop('zones'),
  doFacilityStatusFetch: prop('doFacilityStatusFetch'),
  doUpdateUrl: prop('doUpdateUrl'),
})
